// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__Uoxhm","rowsWrapper":"style_rowsWrapper__gqqz5","rowWrapper":"style_rowWrapper__3b_QT","text":"style_text__2aH0y"};